import {
  GET_CREW_DATA,
  GET_CREW_MANAGEMENT_APPLICATIONS
} from './../constants/actionTypes'
import get from 'lodash/get'

const initStore = {
  persons: [],
  pages: {}
}

const crew = (store = initStore, action = {}) => {
  switch (action.type) {
    case GET_CREW_DATA: {
      const page = get(action, 'data.page', {})
      const persons =
        page.page === 1
          ? get(action, 'data.persons', [])
          : [...get(store, 'persons', []), ...get(action, 'data.persons', [])]
      return {
        page,
        persons
      }
    }
    default:
      return store
  }
}

export const crewManagementApplications = (store = [], action = {}) => {
  if (action.type !== GET_CREW_MANAGEMENT_APPLICATIONS) {
    return store
  }
  return get(action, 'data', [])
}

export default crew
